<div #map style="width:100%;height:700px"></div>